import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
            <i className="ri-movie-2-fill text-background-50 text-lg"></i>
          </div>
          <span className={`font-heading font-bold text-xl transition-colors ${
            scrolled ? 'text-foreground-900' : 'text-background-50'
          }`}>
            琪琪影院
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/'
                ? scrolled ? 'text-primary-600' : 'text-accent-400'
                : scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-background-100/80 hover:text-background-50'
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 5).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.includes(cat.slug)
                  ? scrolled ? 'text-primary-600' : 'text-accent-400'
                  : scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-background-100/80 hover:text-background-50'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${
              location.pathname === '/about'
                ? scrolled ? 'text-primary-600' : 'text-accent-400'
                : scrolled ? 'text-foreground-700 hover:text-foreground-950' : 'text-background-100/80 hover:text-background-50'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
            scrolled ? 'text-foreground-700' : 'text-background-50'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3 flex flex-col gap-2">
          <Link to="/" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap">首页</Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap"
            >
              {cat.name}
            </Link>
          ))}
          <Link to="/about" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap">关于我们</Link>
        </div>
      )}
    </nav>
  );
}